import React from 'react';
import { MediaQueryContext } from './MediaQueryContext';

export default class PageTitle extends React.Component{

  static contextType = MediaQueryContext;
  constructor() {
    super();
    this.state = { scrollPosition: window.scrollY }
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
    
  }
  
  onScroll() {
    this.setState({ scrollPosition: window.scrollY });
  }

  render() {
    /*let fontSize = (100 - this.state.scrollPosition) * 0.02;
    console.log("fontsize: " + fontSize);
    fontSize = Math.min(fontSize, 4);
    fontSize = Math.max(fontSize, 1);

    let style = this.context.isMobile ? {
      fontSize: fontSize + 'em',
    } : {};*/
    let style = {};

    if (this.state.scrollPosition > 50) {
      style.left= `calc(1em - ${this.state.scrollPosition - 50}%)`
    }
    return <h1 style={style} className="page-title">{this.props.children}</h1>

  }
}